export default __webpack_public_path__ + "static/index-title-feature-ja-115a5ef76e15e04be4a98dbf276f01fa.png";